export const getRandomColors = () => {
  const colors = ['FF3162', '6C90F4', 'A334FF', '25C2A4'];
  const randomColor = Math.floor(Math.random() * colors.length);
  return colors[randomColor];
};
